import { QuestionAnswer } from '@/app/(app)/(bottomTabs)/profile/settings/faq';
import { i18n } from '@/utils/i18n';

export const ENV = process.env.EXPO_PUBLIC_ENV;
export const API_URL = process.env.EXPO_PUBLIC_API_URL;
export const ICAC_NPO_ID = process.env.EXPO_PUBLIC_ICAC_NPO_ID;
export const MAX_RETRIES = 3;

// Sentry
export const SENTRY_DSN = process.env.EXPO_PUBLIC_SENTRY_DSN;

// URLs
export const TERMS_OF_USE_URL = `https://www.thereligionbusiness.com/terms-of-service`;
export const PRIVACY_POLICY_URL = `https://www.thereligionbusiness.com/privacy-policy`;

//ToDO: Change for deployed WebApp URLs
// export const TERMS_OF_USE_URL = ENV
//   ? 'https://dev-broken-shepherds-web-app-kappa.vercel.app/terms-of-service'
//   : 'https://app.brokenshepherds.com/terms-of-service';
// export const PRIVACY_POLICY_URL = ENV
//   ? 'https://dev-broken-shepherds-web-app-kappa.vercel.app/privacy-policy'
//   : 'https://app.brokenshepherds.com/privacy-policy';

// Contact email
export const BS_CONTACT_EMAIL = 'contact@brokenshepherds.com';

// Appsflyer deeplink config
const devConfig = {
  c: 'Dev campaign',
  af_og_title: `Broken Shepherds Dev`,
  af_dp: `brokenshepherdsdev:///`,
  af_web_dp: `https://dev-broken-shepherds-web-app-kappa.vercel.app`,
  brandDomain: `brokenshepherdsdev.onelink.me`
};

const prodConfig = {
  c: 'Broken Shepherds Prod',
  af_og_title: `Broken Shepherds`,
  af_dp: `brokenshepherds:///`,
  af_web_dp: `https://app.brokenshepherds.com`,
  brandDomain: `link.brokenshepherds.com`
};

export const APPSFLYER_CONFIG = ENV === 'production' ? prodConfig : devConfig;

// Chromecast
export const CHROMECAST_APPLICATION_ID = '5FC5ADDF';

// Gift Discount
export const GIFT_DISCOUNT_PERCENTAGE = 33.35;

// FAQs
export const FAQS: QuestionAnswer[] = [
  {
    question: i18n.t('faq.what_is_broken_shepherds.question'),
    answer: i18n.t('faq.what_is_broken_shepherds.answer')
  },
  {
    question: i18n.t('faq.what_is_light_rating.question'),
    answer: i18n.t('faq.what_is_light_rating.answer')
  },
  {
    question: i18n.t('faq.can_broken_shepherds_adjust_ratings.question'),
    answer: i18n.t('faq.can_broken_shepherds_adjust_ratings.answer')
  },
  {
    question: i18n.t('faq.who_can_claim_nonprofit.question'),
    answer: i18n.t('faq.who_can_claim_nonprofit.answer')
  },
  {
    question: i18n.t('faq.does_bs_receive_donation.question'),
    answer: i18n.t('faq.does_bs_receive_donation.answer')
  },
  {
    question: i18n.t('faq.does_bs_charge_donation.question'),
    answer: i18n.t('faq.does_bs_charge_donation.answer')
  },
  {
    question: i18n.t('faq.does_bs_store_info.question'),
    answer: i18n.t('faq.does_bs_store_info.answer')
  }
];

//Firebase
export const firebaseConfig = new URLSearchParams({
  apiKey: process.env.EXPO_PUBLIC_FB_API_KEY ?? '',
  authDomain: process.env.EXPO_PUBLIC_FB_AUTH_DOMAIN ?? '',
  projectId: process.env.EXPO_PUBLIC_FB_PROJECT_ID ?? '',
  storageBucket: process.env.EXPO_PUBLIC_FB_STORAGE_BUCKET ?? '',
  messagingSenderId: process.env.EXPO_PUBLIC_FB_MESSAGING_SENDER_ID ?? '',
  appId: process.env.EXPO_PUBLIC_FB_APP_ID ?? '',
  measurementId: process.env.EXPO_PUBLIC_FB_MEASUREMENT_ID ?? ''
}).toString();
